import React, { Fragment, useEffect } from 'react';
import { AddCircleBlue, CustomDelete, FullTable, Loader } from 'components';
import { useDispatch, useSelector } from 'react-redux';
import { FindLoad, sortListByKey, useModal } from 'utils';
import { systemActions } from 'store';
import { CreateEditPlace } from './modals/createEditPlace';
import { PLACE_OF_ACTION_TYPE, placeOfNotYet, placeOfServiceBody, placeOfServiceHead } from './constants';

const ACTION_TYPE = 'GET_PLACES';

export const PlaceOfService = ({  }) => {
    const globalPlaces = useSelector((state) => state.system.places);
    const dispatch = useDispatch();
    const getLoader = FindLoad(ACTION_TYPE);
    const { open } = useModal();

    useEffect(() => {
        dispatch(systemActions.getPlaces());
    }, []);

    const handleAction = (item, name) => {
        if (name === 'edit') open(<CreateEditPlace info={item} />);
        if (name === 'delete') {
            open(
                <CustomDelete
                    info="Delete Place of Service?"
                    text={`Are you sure you want to delete "${item?.name}"?`}
                    handleDel={() => dispatch(systemActions.deletePlaceByIdGlobal(item?.id))}
                    actionType="DELETE_PLACE_BY_ID_GLOBAL"
                />
            );
        }
    };

    if (getLoader?.length) {
        return <Loader />;
    }

    return (
        <Fragment>
            <div className="header-action-btn">
                <AddCircleBlue text={'Add Place of Service'} handleClick={() => open(<CreateEditPlace />)} />
            </div>
            <FullTable
                head={placeOfServiceHead}
                body={placeOfServiceBody}
                loadingType={PLACE_OF_ACTION_TYPE}
                list={globalPlaces?.length ? sortListByKey(globalPlaces, 'name') : []}
                handleClickButton={handleAction}
                notYet={placeOfNotYet}
                margin={'16px 0 0 0'}
            />
        </Fragment>
    );
};
